import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, LocaleX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, Spacer, VStack, XButton, XImage, XText } from "IZOX/_X";
import { SysConfig } from "__SYSDefault/Config";
import _ from "lodash";

/**
 * @augments {Component<Props, State>}
 */
class PricingPlan extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PricingPlan.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _toApply = () => {

  }

  _toPlanDetail = () => {

  }

  renderButton(){
    let {toApply, toPlanDetail} = this.props;
    return (
      <VStack position="absolute" top={120} right={24} spacing={10}>
        <XButton onPress={toApply} width={228} 
          color={ColorX.CSS("pureWhite")} pV={8}
          bgColor={ColorX.CSS("Axit")} round={50}>
          <HStack>
            <XText bold>
              {LocaleX.Parse({
                EN: "Apply now",
                TC: "立即申請"
              })}
            </XText>
          </HStack>
        </XButton>
        <XButton onPress={toPlanDetail} 
          color={ColorX.CSS("Axit")}>
          <HStack>
            <XText bold>
              {LocaleX.Parse({
                EN: "Plan Detail",
                TC: "計劃詳情"
              })}
            </XText>
          </HStack>
        </XButton>
      </VStack>
    );
  }

  renderKeyCoverage(list){
    return (
      <VStack HAlign="[" mV={16}>
        <HStack HAlign="[">
          <XText color={ColorX.CSS("Stone")} fontSize={16} bold>
            {LocaleX.Parse({
              EN: "Key Coverage",
              TC: "主要保障"
            })}
          </XText>
        </HStack>
        <VStack spacing={10} pV={10} HAlign="[">
          {_.map(list, (item, index) => (
            <HStack key={index} HAlign="[" spacing={10}>
              <XImage source={"/Images/home/checkbadge.png"} width={16} height={16}/>
              <XText color={ColorX.CSS("Stone")} fontSize={16} lineHeight={1.5}>
                {LocaleX.Parse(item)}
              </XText>
            </HStack>
          ))}
        </VStack>
      </VStack>
    );
  }

  renderPrice(price, year){
    return (
      <HStack HAlign="[" pV={10} spacing={10}>
        <XText bold color={ColorX.CSS("Leaf")} fontSize={22}>
          {`HK$${price}`}
        </XText>
        <XText color={ColorX.CSS("Grass")} fontSize={16}>
          {`/${year} year`}
        </XText>
      </HStack>
    );
  }

  renderPlanTitle(title, withIcon){
    return (
      <HStack HAlign="[" spacing={10}>
        {withIcon && <XImage source={"/Images/home/crown.png"}/>}
        <XText bold color={ColorX.CSS("Stone")} fontSize={22}>
          {LocaleX.Parse(title)}
        </XText>
      </HStack>
    );
  }

  renderPlanDesc(desc){
    return (
      <HStack HAlign="[">
        <XText color={ColorX.CSS("Stone")} fontSize={16} lineHeight={1.5}>
          {desc}
        </XText>
      </HStack>
    );
  }

  renderBasicPlan(){
    return (
      <HStack HAlign="[">
        <VStack width={"70%"} HAlign="[" position="relative">
          {this.renderPlanTitle({ EN: "Basic Plan", TC: "基本計劃" }, false)}
          {this.renderPrice(710, 1)}
          {this.renderPrice(1280, 1)}
          {this.renderPlanDesc("Meets minimum legal requirements in Hong Kong.")}
          {this.renderKeyCoverage([
            "Employer's Liability",
            "Medical Expenses (e.g., hospitalization, outpatient)",
            "Personal Accident (helper injury/death)",
            "Repatriation"
          ])}
        </VStack>
      </HStack>
    );
  }

  renderElitePlan(){
     return (
      <HStack HAlign="[">
        <VStack width={"70%"} HAlign="[" position="relative">
          {this.renderPlanTitle({ EN: "Elite Plan", TC: "精英計劃" }, true)}
          {this.renderPrice(860, 1)}
          {this.renderPrice(1560, 1)}
          {this.renderPlanDesc("Comprehensive protection for helper and employer.")}
          {this.renderKeyCoverage([
            "All Basic Plan benefts",
            "Critical Illness Coverage (e.g., cancer, stroke, heart attack)"
          ])}
        </VStack>
      </HStack>
    );
  }

  renderPlans(){
    return (
      <VStack width={800} spacing={16}>
        <VStack fullWidth shadow bW={1} bColor={ColorX.CSS("placeholder")}
          position="relative"
          round={15} p={20}>
          {this.renderButton()}
          {this.renderBasicPlan()}
        </VStack>
        <VStack fullWidth shadow bW={2} bColor={ColorX.CSS("Grass")} 
          position="relative"
          round={15} p={20}>
          <HStack position="absolute" bgColor={ColorX.CSS("Grass")} 
            fitWidthToContent pH={24} width={109} height={40}
            round={[0, 0, 10, 10]} top={0} right={80}>
            <XText color={ColorX.CSS("pureWhite")} fontSize={16} bold>
              {LocaleX.Parse({
                EN: "Popular",
                TC: "熱門"
              })}
            </XText>
          </HStack>
          {this.renderButton()}
          {this.renderElitePlan()}
        </VStack>
      </VStack>
    );
  }

  render(){
    return (
      <HStack width={SysConfig.ContentWidth} pH={80} pB={120}>
        <VStack alignSelf="stretch" width={"30%"} HAlign="[" flexShrink={0} VAlign="^">
          <HStack HAlign="[" >
            <XText bold fontSize={32} color={ColorX.CSS("Grass")}>
              {LocaleX.Parse({
                EN: "Pricing Plan",
                TC: "定價計劃"
              })}
            </XText>
          </HStack>
        </VStack>
        <Spacer/>
        {this.renderPlans()}
      </HStack>
    );

  }

}

export default observer(PricingPlan);
